<template>
  <div class="containerFull_asianWinterGames">
    <CompreSportsMeetCommon
      :bigSportsList="bigSportsList"
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></CompreSportsMeetCommon>
  </div>
</template>

<script>
// 亚冬会 容器
import CompreSportsMeetCommon from './compreSportsMeet_common'
import containerFull_data from '@mixins/compreSportsMeet/AWG/containerFull_data'
export default {
  name: 'containerFull_asianWinterGames',
  mixins: [containerFull_data],
  components: {
    CompreSportsMeetCommon,
  },
}
</script>
